import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { useFavorites } from '../contexts/FavoritesContext';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const FavoriteButton = ({ productTitle, size = 'sm', className = '' }) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [animating, setAnimating] = useState(false);
  const active = isFavorite(productTitle);

  const handle = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!user) {
      navigate('/login');
      return;
    }

    setAnimating(true);
    await toggleFavorite(productTitle);
    setTimeout(() => setAnimating(false), 400);
  };

  const sizeClasses = size === 'lg'
    ? 'w-10 h-10'
    : 'w-8 h-8';
  const iconSize = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';

  return (
    <button
      data-testid={`favorite-btn-${productTitle.toLowerCase().replace(/\s+/g, '-')}`}
      onClick={handle}
      aria-label={active ? `Remove ${productTitle} fra favoritter` : `Legg ${productTitle} til i favoritter`}
      aria-pressed={active}
      className={`
        ${sizeClasses} rounded-full flex items-center justify-center transition-all duration-200
        ${active
          ? 'bg-red-50 text-red-500 hover:bg-red-100'
          : 'bg-white/80 backdrop-blur-sm text-stone-400 hover:text-red-400 hover:bg-white'}
        shadow-sm hover:shadow-md
        ${animating ? 'scale-125' : 'scale-100'}
        ${className}
      `}
    >
      <Heart
        className={`${iconSize} transition-all duration-300 ${active ? 'fill-red-500 text-red-500' : ''} ${animating ? 'scale-110' : ''}`}
      />
    </button>
  );
};

export default FavoriteButton;
